import { curry } from 'lib/util'
import { seqModuleAdapterMessageEventsDispatch } from 'app/_shared/events/notification'

/**
 * Reads all notifications
 *
 * @type {(function(...[*]): (*))|*}
 */
const read = curry(
  async (module, component, detail, callback, e) => await seqModuleAdapterMessageEventsDispatch(
    module,
    'read',
    detail,
    callback,
    true,
  )(e),
)

/**
 * Opens a specific notification
 *
 * @type {(function(...[*]): (*))|*}
 */
const show = curry(
  async (module, component, detail, callback, e) => await seqModuleAdapterMessageEventsDispatch(
    module,
    'show',
    detail,
    callback,
    false,
  )(e),
)

/**
 * Updates the incoming notification by toggling the read/unread property
 *
 * @type {(function(...[*]): (*))|*}
 */
const update = curry(
  async (module, component, detail, callback, e) => await seqModuleAdapterMessageEventsDispatch(
    module,
    'update',
    detail,
    callback,
    false,
  )(e),
)

/**
 * Sets the adapters group data to the incoming data
 *
 * @type {(function(...[*]): (*))|*}
 */
const set = curry(
  async (module, component, detail, callback, e) => await seqModuleAdapterMessageEventsDispatch(
    module,
    'set',
    detail,
    callback,
    false,
  )(e),
)

const alertEvents = {
  read,
  show,
  set,
  update,
}

export {
  alertEvents as default,
  read,
  show,
  set,
  update,
}
